const productMode = 'ProductMode';
const designerMode = 'DesignerMode';
const storeMode = 'StoreMode';
const allModes = [productMode, designerMode, storeMode];

export { allModes, designerMode, productMode, storeMode };
